import EventEmitter from 'eventemitter3';
import { SEARCH_FILTERS_OPENED } from '../../events/data-layer-events';
import { pushTrackingEventToDataLayer } from '../../helpers/data-layer-helper';
import Popin from './popin';
import { POPIN_EVENT } from './popinEvent';

export default class PopinManager extends EventEmitter {
  constructor() {
    super();

    this._Popins = {};
    this._Buttons = {};

    this._dom = {};

    this._getDom();
    this._initPopin();
    this._bind();
  }

  isOpened() {
    for (const popinName in this._Popins) {
      if (this._Popins.hasOwnProperty(popinName)) {
        const Popin = this._Popins[popinName];
        if (Popin.isOpened()) {
          return true;
        }
      }
    }
    return false;
  }

  closeAll(name) {
    for (const popinName in this._Popins) {
      if (this._Popins.hasOwnProperty(popinName)) {
        const Popin = this._Popins[popinName];
        if (name != null) {
          if (Popin.getName() != name) {
            Popin.close(false);
          }
        } else {
          Popin.close(false);
        }
      }
    }
  }

  updateAllCounters(values) {
    if (Object.keys(values).length === 0 && values.constructor === Object) {
      return;
    }

    this._loopPopins((e) => {
      const _arrayFilters = e._container.getAttribute('data-filters').split(',');
      let _count = 0;
      for (let i = 0; i < _arrayFilters.length; i++) {
        const el = _arrayFilters[i];
        const value = values[el];
        if (value !== null && (value.length > 0 || value > 0)) {
          _count++;
        }
      }

      this._Buttons[e._name].setCounter(_count);
    });
  }

  _loopPopins(callback) {
    for (const popinName in this._Popins) {
      if (this._Popins.hasOwnProperty(popinName)) {
        const Popin = this._Popins[popinName];
        callback(Popin);
      }
    }
  }

  _bind() {
    // Open Popins
    for (let i = 0, j = this._dom.btn.length; i < j; i++) {
      const el = this._dom.btn[i];
      const name = el.getAttribute('data-name');
      this._Buttons[name] = new ButtonFilter(el, name);
      el.addEventListener('click', this._btnClicked.bind(this, name));
    }

    this._loopPopins((Popin) => {
      Popin.on(POPIN_EVENT.OPENED, (name) => {
        this.emit(POPIN_EVENT.OPENED);
        if (name === 'popin-all-filters' || name === 'popin-filter-search') {
          pushTrackingEventToDataLayer(SEARCH_FILTERS_OPENED, { name });
        }
      });
      Popin.on(POPIN_EVENT.CLOSED, (name) => {
        this.emit(POPIN_EVENT.CLOSED, name);
      });
    });
  }

  _btnClicked(name) {
    const Popin = this._Popins[name];
    if (Popin.isOpened() === false) {
      Popin.open();
      this.closeAll(name);
    } else {
      Popin.close(true);
    }
  }

  _getDom() {
    // POPINS
    this._dom.body = document.body;
    this._dom.filters = this._dom.body.querySelector(
      '.js-filters-container-bar',
    );
    this._dom.btn = this._dom.body.querySelectorAll('.js-open-filter-popin');
    this._dom.popin = this._dom.body.querySelectorAll('.js-popin-filter');
  }

  _initPopin() {
    for (let i = 0, j = this._dom.popin.length; i < j; i++) {
      const popin = this._dom.popin[i];
      const name = popin.getAttribute('data-name');
      this._Popins[name] = new Popin(name, popin);
    }
  }

  _popinLoop(callback) {
    for (let i = 0, j = this._Popins.length; i < j; i++) {
      const Popin = this._Popins[i];
      callback();
    }
  }
}

class ButtonFilter {
  constructor(btn, name) {
    this._name = name;
    this._getDom(btn);
  }

  _getDom(btn) {
    this._dom = {};
    this._dom.btn = btn;
    this._dom.quantity = this._dom.btn.querySelector('.filter-quantity');
  }

  setCounter(number) {
    if (this._dom.quantity === null) {
      return;
    }

    if (number > 0) {
      this._dom.quantity.classList.add('show');
      this._dom.quantity.innerHTML = number;
    } else {
      this._dom.quantity.classList.remove('show');
    }
  }
}
